"use client";

import { c as _c } from "react/compiler-runtime";
import { initTracking } from "@justhome/common";
import { configureCommon } from "@lib/commonConfig";
import { parseUTM, saveUTM } from "@lib/utm";
import { useEffect } from "react";

// What `_app` does for the Pages Router. Once per client bundle, at module scope: the body
// listener `initTracking` adds is never removed, so a second call counts every event twice.
configureCommon();
initTracking();
const AppBootstrap = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
};
export default AppBootstrap;
function _temp() {
  saveUTM(parseUTM(Object.fromEntries(new URLSearchParams(location.search))));
}